import { Paper, Typography } from "@mui/material";

import { makeStyles } from "../../../../../../theme/theme";

const useClasses = makeStyles()((theme) => ({
  root: {
    marginLeft: `${theme.layout.main.horizontalMargin}px`,
    marginRight: `${theme.layout.main.horizontalMargin}px`,
    marginTop: "20px",
  },
}));

function StyleGuide() {
  const { classes } = useClasses();
  return (
    <Paper className={classes.root} elevation={0}>
      <Typography variant="h1">Heading 1</Typography>
      <Typography variant="h2">Heading 2</Typography>
      <Typography variant="h3">Heading 3</Typography>
      <Typography variant="h4">Heading 4</Typography>
      <Typography variant="h5">Heading 5</Typography>
    </Paper>
  );
}

export default StyleGuide;
